import { RefundPolicyRepository } from '@/core/domain/refund-policy/repositories/refund-policy.respository';
import { GetRefundPolicyUseCase } from '@/core/domain/refund-policy/usecases/getRefundPolicy.usecase';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RefundPolicyImplRepository } from './refund-policy-imp.respository';

const getRefundPolicyUseCaseFactory = (repository: RefundPolicyRepository) =>
    new GetRefundPolicyUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetRefundPolicyUseCase,
            useFactory: getRefundPolicyUseCaseFactory,
            deps: [RefundPolicyImplRepository],
        },
        {
            provide: RefundPolicyRepository,
            useClass: RefundPolicyImplRepository,
        },
    ],
})
export class RefundPolicyDataModule {}
